import { render, staticRenderFns } from "./exExpertScoringTab.vue?vue&type=template&id=553b18d9&scoped=true"
import script from "./exExpertScoringTab.vue?vue&type=script&lang=js"
export * from "./exExpertScoringTab.vue?vue&type=script&lang=js"
import style0 from "./exExpertScoringTab.vue?vue&type=style&index=0&id=553b18d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553b18d9",
  null
  
)

export default component.exports